import { ChangeDetectorRef, ElementRef } from '@angular/core';

import { AppLayoutService } from '@jct/ui';

export function scrollRegistrationEntryEditorIntoView(
  host: ElementRef<HTMLElement>,
  cdr: ChangeDetectorRef,
  appLayout: AppLayoutService,
): void {
  if (!appLayout.isMobile) {
    return;
  }

  cdr.detectChanges();

  requestAnimationFrame(() => {
    const editor = host.nativeElement.querySelector(
      '.registration-entry-editor',
    ) as HTMLElement;

    if (!editor) {
      return;
    }

    const toolbar = document.querySelector('[ui-toolbar] .mat-toolbar') as HTMLElement;
    const viewportTop = toolbar ? toolbar.getBoundingClientRect().bottom : 0;
    const viewportBottom = window.innerHeight;
    const viewportHeight = viewportBottom - viewportTop;
    const rect = editor.getBoundingClientRect();

    if (rect.height >= viewportHeight) {
      window.scrollBy({ top: rect.top - viewportTop, behavior: 'smooth' });
      return;
    }

    const fullyVisible = rect.top >= viewportTop && rect.bottom <= viewportBottom;

    if (fullyVisible) {
      return;
    }

    window.scrollBy({ top: rect.bottom - viewportBottom, behavior: 'smooth' });
  });
}
